import { Component, inject, input, output, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { file } from 'jszip';
import { CameraService } from '../image-uploader/camera/camera.service';
import { getDownloadURL } from 'firebase/storage';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-file-input',
  imports: [
    MatTooltip,
    MatProgressSpinner,
  ],
  templateUrl: './file-input.component.html',
  styleUrl: './file-input.component.scss'
})
export class FileInputComponent {

  private readonly cameraService = inject(CameraService);

  control = input.required<FormControl>();

  uploaded = output<string>();

  private readonly snackBar =  inject(MatSnackBar);

  uploading = signal<boolean>(false);


  onUpload(fileInput: HTMLInputElement) {
    fileInput.click();
  }

  uploadFile(event: any): void {
    if (!event?.target?.files || !(event.target.files.length > 0)) {
      return;
    }

    const file = event.target.files[0];

    if (!this.checkFile(file)) {
      return;
    }

    this.uploading.set(true);
    const uploadTask = this.cameraService.saveImage(file);

    uploadTask.on(
      'state_changed',
      () => {},
      (error) => { console.error(error); this.uploading.set(false); },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          this.control().setValue(downloadURL);
          this.uploaded.emit(downloadURL);
          this.uploading.set(false);
        });
      }
    );





  }

  checkFile(file): boolean {
    console.log(file);
    if (file.size > 2e+7) {
      this.snackBar.open(
        `El Archivo ${file.name} es muy pesado.`,
        'Cerrar',
        { duration: 2000, panelClass: ['snackbar-error'] }
      );
      return false;
    } else if (!file.type || (file.type.indexOf('image/') === -1 && file.type.indexOf('pdf') === -1)) {
      this.snackBar.open(
        `El Formato ${file.type} no es compatible.`,
        'Cerrar',
        { duration: 2000, panelClass: ['snackbar-error'] }
      );
      return false;
    }

    return true
  }

  downloadFile(anchor: HTMLAnchorElement): void {
    anchor.click();
  }

}
